var map = {
	"./compare-0.jpg": "51ae",
	"./compare-1.jpg": "ea8f",
	"./compare-2.jpg": "ca65",
	"./compare-3.jpg": "0d6f",
	"./compare-4.jpg": "a6f4",
	"./compare-5.jpg": "c3a5",
	"./compare-6.jpg": "42ab"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5eaf";